import React from "react";
import Navbar from "../Components/Navebar/Navbar";
import Hero from "../Components/HeroSection/Hero";
import Features from "../Components/features/Features";
import WebsiteSupported from "../Components/websiteSupported/WebsiteSupported";
import MobileVersion from "../Components/mobileVersion/MobileVersion";
import FAQ from "../Components/FAQ/FAQ";
import Footer from "../Components/Footer/Footer";
import "./VideoDownloader.css";
import VideoDownloaderCard from "../Components/AppCard/VideoDownloaderCard";
import Instructions from "../Components/GenericInstructions/Instructions";
import { useApp } from "../AppContext/AppContext";

const VideoDownloader = () => {
  const { selectedApp } = useApp();

  return (
    <div className="video-downloader">
      <Navbar />
      <div id="home">
        <Hero />
      </div>
      {/* <VideoDownloaderCard /> */}
      <div id="instructions">
        <Instructions />
      </div>
      {!selectedApp && (
        <div id="features">
          <Features />
        </div>
      )}
      <div id="supported-sites">
        <WebsiteSupported />
      </div>
      <MobileVersion />
      <div id="faqs">
        <FAQ />
      </div>
      <Footer />
    </div>
  );
};

export default VideoDownloader;
